import { PropsWithoutRef, ReactNode, DOMAttributes } from 'react';
import './InfoCard.scss';

export type CardProps = {
	title: string;
	description?: string;
	readMore?: ReactNode;
	html?: DOMAttributes<HTMLDivElement>['dangerouslySetInnerHTML'];
	verticalSpacing?: boolean;
};

export default function InfoCard({
	title,
	description,
	readMore,
	html,
	verticalSpacing,
}: PropsWithoutRef<CardProps>) {
	return (
		<div className={`InfoCard${verticalSpacing ? ' InfoCard-vertical-spacing' : ''}`}>
			<div className="InfoCard-container">
				<div className="InfoCard-title text-subtitle2">
					<span className="text-text-primary">{title}</span>
				</div>
				<div className="InfoCard-body text-body3">
					<div
						className="InfoCard-html-content text-text-primary"
						dangerouslySetInnerHTML={html}
					></div>
					<div className="InfoCard-body-content text-text-primary">{description}</div>
				</div>
				{readMore}
			</div>
		</div>
	);
}
